import { defineMessage } from 'services/localization';

export const messages = {
    learnMore: defineMessage('learn_more'),
    unableToConfirm: defineMessage('unable_to_confirm_the_payment'),
    thereWasAnIssue: defineMessage('oops_there_was_an_issue_confirming_the_payment'),
    retry: defineMessage('try_again'),
};
